import * as React from 'react';
import { Container, DependencyContainerContext } from '@symbiotic/green-state';

export const rootComponentBuilder = (Component: any) => {
  return class RootComponent extends React.Component<{ container: Container}> {
    render() {
      const { container, ...other } = this.props;
      return (
        <DependencyContainerContext container={container}>
          <Component {...other} />
        </DependencyContainerContext>
      );
    }
    componentDidCatch(err: Error): void {
      console.log(`error while rendering root component`, err);
      // swallowing errors so they are isolated to the plugin and do not impact the main portal app
    }
  };
};




// WEBPACK FOOTER //
// ./src/framework/reactHelpers.tsx